export const switchStyles = {
  baseStyle: {
    // Track zawsze widoczny: szary gdy OFF, primary (fiolet) gdy ON; biały thumb.
    track: {
      bg: "gray.300",

      _checked: {
        bg: "primary"
      }
    },
    thumb: {
      bg: "white"
    }
  },
  variants: {
    consent: {
      track: {
        w: "51px",
        h: "21px",
        alignItems: "center",
        p: "0px",

        _checked: {
          justifyContent: "right"
        }
      },
      thumb: {
        h: "14px",
        w: "14px",
        ml: "5px",

        _checked: {
          ml: 0,
          mr: "21px"
        }
      }
    }
  }
};
